/* ShonenSports — aperçu EN DIRECT du nom et du numéro sur les pages produit classiques (06/10/2026).
   La carte affiche d'abord une image pré-calculée du dos du coloris (nom et numéro d'origine, mêmes rendus que le moteur), puis, dès que le
   client touche le champ nom ou numéro, le moteur partagé ss-moteur.js prend le relais et recalcule la photo du dos à chaque lettre.
   Design = le design d'origine du coloris sans le nom ni le numéro (catalogue : coloris[id].gabarit_produit) ; champ vide = nom/numéro d'origine.
   Données du produit (snippet ss-apercu-produits) : coloris du catalogue et image de départ, dans l'ordre de l'option Coloris. */
(function () {
  if (window.ssApercuProduit) return; window.ssApercuProduit = true;
  const section = document.querySelector('.ss-pack-section');
  const cartes = section ? [...section.querySelectorAll('[data-ss-apercu]')] : [];
  if (!cartes.length || !window.SSMoteur) return;
  let D = {}; try { D = JSON.parse(section.querySelector('[data-ss-apercu-donnees]').textContent); } catch (e) { return; }
  const CADRAGE = [150, 40, 724, 724];                       // dos de la photo 1024 : des épaules au bas du numéro (même cadrage que les images de départ)
  const premiere = cartes[0].dataset;
  let M = null, CAT = null, actif = false, attente = null;
  const etat = { coloris: null, gabarit: 'produit', nom: '', numero: '' };
  const tampon = document.createElement('canvas'); tampon.width = tampon.height = 1024;

  function indexColoris(val) {
    const rangee = section.querySelector('[data-coloris-row]'); if (!rangee) return 0;
    const btns = [...rangee.querySelectorAll('.ss-pack-coloris-btn')];
    const i = val != null ? btns.findIndex(b => b.dataset.coloris === val) : btns.findIndex(b => b.classList.contains('selected'));
    return Math.max(0, i);
  }
  function lien() {                                         // « Personnalise-le à 100 % » : ouvre le configurateur sur ce coloris
    section.querySelectorAll('[data-ss-apercu-lien]').forEach(a => {
      try { const u = new URL(a.href, location.href); if (etat.coloris) u.searchParams.set('coloris', etat.coloris); a.href = u.toString(); } catch (e) {}
    });
  }
  function colorisCourant(val) {
    const i = indexColoris(val), id = (D.coloris || [])[i] || null, img = (D.images || [])[i] || null;
    etat.coloris = id; lien();
    cartes.forEach(c => {
      c.hidden = !id;
      const im = c.querySelector('img'); if (img && im && im.getAttribute('src') !== img) im.src = img;
    });
    return id;
  }
  function lireChamps() {
    const n = section.querySelector('[data-name-input]'), k = section.querySelector('[data-num-input]');
    etat.nom = n ? n.value.trim() : ''; etat.numero = k ? k.value.replace(/\D/g, '').slice(0, 2) : '';
  }
  async function rendre() {
    if (!CAT || !etat.coloris) return;                       // moteur encore en chargement : le rendu se fera à la fin d'activer()
    const t = CAT.textes[CAT.coloris[etat.coloris].modele] || {};
    const e = Object.assign({}, etat, { nom: etat.nom || t.nom_origine || '', numero: etat.numero !== '' ? etat.numero : (t.num_origine ?? '') });
    if (!(await M.rendre(e, { dos: [tampon] }))) return;
    cartes.forEach(c => {
      const cv = c.querySelector('canvas'); cv.getContext('2d').drawImage(tampon, ...CADRAGE, 0, 0, cv.width, cv.height);
      cv.hidden = false; c.classList.remove('ss-apercu--charge'); c.classList.add('ss-apercu--direct');
    });
  }
  const plusTard = () => { clearTimeout(attente); attente = setTimeout(() => { lireChamps(); rendre(); }, 120); };
  async function activer() {                               // premier contact avec le nom/numéro : chargement du moteur (cartes du dos seulement)
    if (actif) return; actif = true;
    cartes.forEach(c => c.classList.add('ss-apercu--charge'));
    M = SSMoteur({ assets: premiere.assets, prefixe: premiere.prefixe, catalogue: premiere.catalogue, faces: ['dos'] });
    try { CAT = await M.charge; await M.demarrer(); lireChamps(); await rendre(); }
    catch (e) { cartes.forEach(c => c.classList.remove('ss-apercu--charge')); }   // pas de WebGL2 : on garde l'image de départ
  }

  colorisCourant(null);
  document.addEventListener('ss:coloris:change', ev => { colorisCourant(ev.detail && ev.detail.coloris); if (actif) rendre(); });
  section.querySelectorAll('[data-name-input], [data-num-input]').forEach(i => {
    i.addEventListener('focus', activer, { once: true }); i.addEventListener('pointerdown', activer, { once: true });
    i.addEventListener('input', () => { activer(); if (actif) plusTard(); });
  });
  section.querySelectorAll('[data-num-dec], [data-num-inc]').forEach(b => b.addEventListener('click', () => { activer(); plusTard(); }));
  cartes.forEach(c => c.addEventListener('click', () => { activer(); const n = section.querySelector('[data-name-input]'); if (n && n.offsetParent) n.focus(); }));
})();
